import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { BulkActionLoaderDialogProps } from '@confluence/page-selection-table/entry-points/PageSelectionTable.ts';

export const BulkArchivePagesLoader: LoadableType<BulkActionLoaderDialogProps> = LoadableAfterPaint(
	{
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-BulkArchivePagesLoader" */ '../src/BulkArchivePagesLoader.tsx'
				)
			).BulkArchivePagesLoader,
	},
);
